import React from 'react';
import PropTypes from 'prop-types';

const baseClassName = 'WorkspaceContent';

const WorkspaceContent = ({ children }) => <main className={baseClassName}>{children}</main>;

WorkspaceContent.propTypes = {
    children: PropTypes.node.isRequired,
};

export default WorkspaceContent;
